export interface IDonorProfileAdpRecipient {
    id: number,
    alias: string
}